var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file 6, document, text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.8334 2.5H5.00002C4.53978 2.5 4.16669 2.8731 4.16669 3.33333V16.6667C4.16669 17.1269 4.53978 17.5 5.00002 17.5H15C15.4603 17.5 15.8334 17.1269 15.8334 16.6667V7.5M10.8334 2.5L15.8334 7.5M10.8334 2.5V6.66667C10.8334 7.1269 11.2064 7.5 11.6667 7.5H15.8334M7.50002 10.8333H10M7.50002 14.1667H12.9167",
    stroke: "#889096",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.8dbcd25ab6cda7e6a3176503ec57ff41.svg";
export { ForwardRef as ReactComponent };